import { useState, useEffect, useCallback, useRef } from "react";
import axiosInstance from "../../api/axiosInstance";

const TOAST_DURATION = 4000;

const bankApi = {
  get: (vendorProfileId) =>
    axiosInstance.get(`/api/superadmin/vendors/${vendorProfileId}/bank/`),

  create: (vendorProfileId, body) =>
    axiosInstance.post(`/api/superadmin/vendors/${vendorProfileId}/bank/`, body),

  patch: (vendorProfileId, id, body) =>
    axiosInstance.patch(`/api/superadmin/vendors/${vendorProfileId}/bank/${id}/`, body),

  patchCheque: (vendorProfileId, id, formData) =>
    axiosInstance.patch(`/api/superadmin/vendors/${vendorProfileId}/bank/${id}/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  delete: (vendorProfileId, id) =>
    axiosInstance.delete(`/api/superadmin/vendors/${vendorProfileId}/bank/${id}/`),

  searchBanks: (q = "") =>
    axiosInstance.get(`/api/vendors/banks/?q=${encodeURIComponent(q)}`),
};

const CloseIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const LoaderIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    style={{ animation: "bk-spin 0.8s linear infinite", flexShrink: 0 }}>
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
  </svg>
);
const BankIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);
const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);
const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);
const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const RefreshIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);
const UploadIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="16 16 12 12 8 16" />
    <line x1="12" y1="12" x2="12" y2="21" />
    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
  </svg>
);
const EyeIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const ChevronDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const AlertTriangleIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const LockIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const CheckIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const UserIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const CalendarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const MapPinIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const FileIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);
const LinkIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

let _bkToastSetter = null;
const toast = {
  _push: (item) => {
    const id = Date.now() + Math.random();
    _bkToastSetter?.((p) => [...p, { id, ...item }]);
    return id;
  },
  success: (title, msg) => toast._push({ type: "success", title, msg }),
  error:   (title, msg) => toast._push({ type: "error",   title, msg }),
  info:    (title, msg) => toast._push({ type: "info",    title, msg }),
  loading: (title)      => toast._push({ type: "loading", title, persistent: true }),
  dismiss: (id)         => _bkToastSetter?.((p) => p.filter((t) => t.id !== id)),
};
const TOAST_META = {
  success: { bar: "#16a34a", icon: "✓" },
  error:   { bar: "#dc2626", icon: "✕" },
  info:    { bar: "#1d4ed8", icon: "i" },
  loading: { bar: "#94a3b8", icon: null },
};
const ToastItem = ({ t, onDismiss }) => {
  const meta = TOAST_META[t.type];
  const [progress, setProgress] = useState(100);
  const [exiting, setExiting]   = useState(false);
  const rafRef  = useRef(null);
  const startTs = useRef(Date.now());
  const dismiss = useCallback(() => {
    setExiting(true);
    setTimeout(() => onDismiss(t.id), 280);
  }, [t.id, onDismiss]);
  useEffect(() => {
    if (t.persistent) return;
    const tick = () => {
      const pct = Math.max(0, 100 - ((Date.now() - startTs.current) / TOAST_DURATION) * 100);
      setProgress(pct);
      if (pct > 0) rafRef.current = requestAnimationFrame(tick);
      else dismiss();
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [t.persistent, dismiss]);
  return (
    <div style={{ position: "relative", overflow: "hidden", background: "#fff", borderRadius: 10, borderLeft: `4px solid ${meta.bar}`, boxShadow: "0 4px 20px rgba(0,0,0,.10), 0 0 0 1px rgba(0,0,0,.06)", minWidth: 300, maxWidth: 360, animation: exiting ? "bk-alOut .28s ease forwards" : "bk-alIn .28s cubic-bezier(.34,1.56,.64,1) forwards" }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "13px 14px 14px" }}>
        <div style={{ flexShrink: 0, width: 24, height: 24, borderRadius: "50%", background: `${meta.bar}18`, display: "flex", alignItems: "center", justifyContent: "center", marginTop: 1 }}>
          {t.type === "loading"
            ? <svg width="13" height="13" viewBox="0 0 13 13" fill="none" style={{ animation: "bk-spin .85s linear infinite" }}><circle cx="6.5" cy="6.5" r="5" stroke={meta.bar} strokeWidth="2" strokeDasharray="8 20" strokeLinecap="round" /></svg>
            : <span style={{ fontSize: 11, fontWeight: 800, color: meta.bar, lineHeight: 1 }}>{meta.icon}</span>}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ margin: 0, fontSize: 13.5, fontWeight: 650, color: "#0f172a", lineHeight: 1.35 }}>{t.title}</p>
          {t.msg && <p style={{ margin: "3px 0 0", fontSize: 12.5, color: "#64748b", lineHeight: 1.5 }}>{t.msg}</p>}
        </div>
        <button onClick={dismiss} style={{ background: "none", border: "none", cursor: "pointer", color: "#cbd5e1", padding: 2, flexShrink: 0, display: "flex", borderRadius: 4 }}
          onMouseEnter={(e) => e.currentTarget.style.color = "#94a3b8"}
          onMouseLeave={(e) => e.currentTarget.style.color = "#cbd5e1"}>
          <CloseIcon />
        </button>
      </div>
      {!t.persistent && (
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 3, background: "#f1f5f9" }}>
          <div style={{ height: "100%", width: `${progress}%`, background: meta.bar, transition: "width .1s linear", borderRadius: "0 2px 0 0" }} />
        </div>
      )}
    </div>
  );
};
const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);
  _bkToastSetter = setToasts;
  const dismiss = useCallback((id) => setToasts((p) => p.filter((t) => t.id !== id)), []);
  if (!toasts.length) return null;
  return (
    <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999, display: "flex", flexDirection: "column", gap: 10, alignItems: "flex-end" }}>
      {toasts.map((t) => <ToastItem key={t.id} t={t} onDismiss={dismiss} />)}
    </div>
  );
};

const InfoRow = ({ icon, label, value, mono, badge }) => (
  <div style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "7px 0", borderBottom: "1px solid #f8fafc" }}>
    <span style={{ color: "#94a3b8", display: "flex", flexShrink: 0, marginTop: 1 }}>{icon}</span>
    <span style={{ fontSize: 12.5, color: "#94a3b8", fontWeight: 550, minWidth: 160, flexShrink: 0 }}>{label}</span>
    {badge ? badge : (
      <span style={{ fontSize: 13, color: mono ? "#1e40af" : "#1e293b", fontWeight: mono ? 700 : 500, fontFamily: mono ? "monospace" : "inherit", flex: 1, wordBreak: "break-word" }}>
        {value ?? <span style={{ color: "#cbd5e1" }}>—</span>}
      </span>
    )}
  </div>
);


const SkeletonBlock = ({ w, h = 14 }) => (
  <div style={{ height: h, width: w, borderRadius: 6, background: "linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%)", backgroundSize: "200% 100%", animation: "bk-shimmer 1.4s infinite" }} />
);

const ConfirmDeleteModal = ({ onConfirm, onCancel, loading }) => (
  <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000, padding: 20 }}
    onClick={onCancel}>
    <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 400, padding: 28, boxShadow: "0 24px 64px rgba(0,0,0,.20)", animation: "bk-fadeUp .2s ease" }}
      onClick={(e) => e.stopPropagation()}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, textAlign: "center" }}>
        <div style={{ width: 52, height: 52, borderRadius: "50%", background: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <div>
          <h3 style={{ margin: "0 0 6px", fontSize: 17, fontWeight: 700, color: "#0f172a" }}>Delete Bank Record?</h3>
          <p style={{ margin: 0, fontSize: 13.5, color: "#64748b", lineHeight: 1.6 }}>This will permanently remove the bank account details for this vendor. This action cannot be undone.</p>
        </div>
        <div style={{ display: "flex", gap: 10, marginTop: 8, width: "100%" }}>
          <button onClick={onCancel} disabled={loading}
            style={{ flex: 1, padding: "10px 0", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", background: "#fff", color: "#374151" }}>
            Cancel
          </button>
          <button onClick={onConfirm} disabled={loading}
            style={{ flex: 1, padding: "10px 0", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", background: loading ? "#fca5a5" : "#dc2626", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
            {loading ? <><LoaderIcon size={14} /> Deleting…</> : <><TrashIcon /> Delete</>}
          </button>
        </div>
      </div>
    </div>
  </div>
);

const BankSearchDropdown = ({ value, selectedBank, onChange, onSelect, error }) => {
  const [query,    setQuery]    = useState("");
  const [results,  setResults]  = useState([]);
  const [open,     setOpen]     = useState(false);
  const [fetching, setFetching] = useState(false);
  const containerRef = useRef(null);
  const debounceRef  = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const searchBanks = useCallback(async (q) => {
    setFetching(true);
    try {
      const { data } = await bankApi.searchBanks(q);
      setResults(Array.isArray(data) ? data : (data?.results ?? data?.data ?? []));
    } catch {
      setResults([]);
    } finally {
      setFetching(false);
    }
  }, []);

  const handleInputChange = (val) => {
    setQuery(val);
    onChange(null); 
    setOpen(true);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => searchBanks(val), 300);
  };

  const handleFocus = () => {
    setOpen(true);
    if (!results.length) searchBanks(query);
  };

  const handleSelect = (bank) => {
    setQuery(bank.name || bank.bank_name || String(bank.id));
    onSelect(bank);
    setOpen(false);
  };

  const displayValue = selectedBank
    ? (selectedBank.name || selectedBank.bank_name || String(selectedBank.id))
    : query;

  return (
    <div ref={containerRef} style={{ position: "relative" }}>
      <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", letterSpacing: ".03em", display: "block", marginBottom: 4 }}>
        Bank Name <span style={{ color: "#dc2626" }}>*</span>
      </label>
      <div style={{ position: "relative" }}>
        <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", pointerEvents: "none" }}>
          <SearchIcon />
        </span>
        <input
          value={displayValue}
          onChange={(e) => handleInputChange(e.target.value)}
          onFocus={handleFocus}
          placeholder="Search bank name…"
          style={{ width: "100%", padding: "9px 36px 9px 32px", border: `1px solid ${error ? "#fca5a5" : "#e2e8f0"}`, borderRadius: 8, fontSize: 13, background: "#fff", color: "#1e293b", outline: "none", boxSizing: "border-box", transition: "border-color .15s" }}
          onFocus2={(e) => e.target.style.borderColor = "#3b82f6"}
          onBlur={(e)  => e.target.style.borderColor = error ? "#fca5a5" : "#e2e8f0"}
        />
        <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", pointerEvents: "none" }}>
          {fetching ? <LoaderIcon size={14} /> : <ChevronDownIcon />}
        </span>
      </div>
      {error && <span style={{ fontSize: 11.5, color: "#dc2626", display: "flex", alignItems: "center", gap: 4, marginTop: 4 }}><AlertTriangleIcon />{error}</span>}

      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,.12)", zIndex: 1000, maxHeight: 220, overflowY: "auto" }}>
          {fetching ? (
            <div style={{ padding: "14px", display: "flex", alignItems: "center", gap: 8, color: "#94a3b8", fontSize: 13 }}>
              <LoaderIcon size={14} /> Searching banks…
            </div>
          ) : results.length === 0 ? (
            <div style={{ padding: "14px", color: "#94a3b8", fontSize: 13, textAlign: "center" }}>
              {query.length > 0 ? "No banks found" : "Type to search banks"}
            </div>
          ) : results.map((bank) => (
            <div key={bank.id}
              onClick={() => handleSelect(bank)}
              style={{ padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f8fafc", transition: "background .1s" }}
              onMouseEnter={(e) => e.currentTarget.style.background = "#f8fafc"}
              onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{bank.name || bank.bank_name}</div>
              {bank.ifsc_prefix && <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 1 }}>IFSC Prefix: {bank.ifsc_prefix}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const ChequeUploadModal = ({ vendorProfileId, bankId, onClose, onSuccess }) => {
  const [file,       setFile]       = useState(null);
  const [preview,    setPreview]    = useState(null);
  const [uploading,  setUploading]  = useState(false);
  const [dragOver,   setDragOver]   = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => { document.body.style.overflow = ""; document.removeEventListener("keydown", onKey); };
  }, [onClose]);

  const handleFile = (f) => {
    if (!f) return;
    const allowed = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];
    if (!allowed.includes(f.type)) {
      toast.error("Invalid File", "Only JPG, PNG, or PDF files are allowed.");
      return;
    }
    if (f.size > 5 * 1024 * 1024) {
      toast.error("File Too Large", "Maximum file size is 5 MB.");
      return;
    }
    setFile(f);
    if (f.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (ev) => setPreview(ev.target.result);
      reader.readAsDataURL(f);
    } else {
      setPreview(null);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const dropped = e.dataTransfer.files[0];
    if (dropped) handleFile(dropped);
  };

  const handleUpload = async () => {
    if (!file) { toast.error("No File", "Please select a file to upload."); return; }
    setUploading(true);
    const loadId = toast.loading("Uploading cheque…");
    try {
      const formData = new FormData();
      formData.append("cancelled_cheque", file);
      if (!bankId) throw new Error("Bank record id is missing.");
      const { data } = await bankApi.patchCheque(vendorProfileId, bankId, formData);
      if (data?.status >= 400) {
        throw new Error(data?.data?.detail || data?.message || "Upload failed");
      }
      toast.dismiss(loadId);
      toast.success("Cheque Uploaded", "Cancelled cheque has been uploaded successfully.");
      onSuccess(data?.data ?? data);
      onClose();
    } catch (err) {
      toast.dismiss(loadId);
      toast.error("Upload Failed", err.message || "Could not upload the file.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 }}
      onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 480, boxShadow: "0 24px 64px rgba(0,0,0,.20)", animation: "bk-fadeUp .2s ease" }}
        onClick={(e) => e.stopPropagation()}>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f1f5f9" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 9, background: "linear-gradient(135deg,#3b82f6,#1d4ed8)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <UploadIcon />
            </div>
            <div>
              <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#0f172a" }}>Upload Cancelled Cheque</h2>
              <p style={{ margin: "2px 0 0", fontSize: 12, color: "#94a3b8" }}>JPG, PNG or PDF · Max 5 MB</p>
            </div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex", padding: 6, borderRadius: 6 }}
            onMouseEnter={(e) => e.currentTarget.style.color = "#64748b"}
            onMouseLeave={(e) => e.currentTarget.style.color = "#94a3b8"}>
            <CloseIcon />
          </button>
        </div>

        <div style={{ padding: "20px 24px 24px" }}>
          <div
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current?.click()}
            style={{ border: `2px dashed ${dragOver ? "#3b82f6" : file ? "#22c55e" : "#e2e8f0"}`, borderRadius: 12, padding: "28px 20px", textAlign: "center", cursor: "pointer", background: dragOver ? "#eff6ff" : file ? "#f0fdf4" : "#f8fafc", transition: "all .2s", marginBottom: 16 }}>
            <input ref={fileInputRef} type="file" accept="image/jpeg,image/png,image/jpg,application/pdf" style={{ display: "none" }} onChange={(e) => handleFile(e.target.files[0])} />
            {preview ? (
              <img src={preview} alt="Preview" style={{ maxHeight: 160, maxWidth: "100%", borderRadius: 8, objectFit: "contain" }} />
            ) : (
              <>
                <div style={{ width: 44, height: 44, borderRadius: "50%", background: file ? "#dcfce7" : "#e2e8f0", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px" }}>
                  {file ? <CheckIcon /> : <UploadIcon />}
                </div>
                <p style={{ margin: "0 0 4px", fontSize: 14, fontWeight: 600, color: "#374151" }}>
                  {file ? file.name : "Click or drag & drop"}
                </p>
                <p style={{ margin: 0, fontSize: 12.5, color: "#94a3b8" }}>
                  {file ? `${(file.size / 1024).toFixed(0)} KB` : "Supported: JPG, PNG, PDF"}
                </p>
              </>
            )}
          </div>

          {file && (
            <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "9px 12px", background: "#f0fdf4", borderRadius: 8, border: "1px solid #bbf7d0", marginBottom: 16 }}>
              <FileIcon />
              <span style={{ fontSize: 12.5, fontWeight: 600, color: "#166534", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
              <button onClick={(e) => { e.stopPropagation(); setFile(null); setPreview(null); }}
                style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex", padding: 2 }}>
                <CloseIcon />
              </button>
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button onClick={onClose} disabled={uploading}
              style={{ padding: "9px 20px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: "pointer", background: "#fff", color: "#374151" }}>
              Cancel
            </button>
            <button onClick={handleUpload} disabled={uploading || !file}
              style={{ padding: "9px 22px", border: "none", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: (uploading || !file) ? "not-allowed" : "pointer", background: (uploading || !file) ? "#93c5fd" : "#3b82f6", color: "#fff", display: "flex", alignItems: "center", gap: 7 }}>
              {uploading ? <><LoaderIcon size={14} /> Uploading…</> : <><UploadIcon /> Upload Cheque</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ACCOUNT_TYPES = [
  { value: "savings",  label: "Savings"  },
  { value: "current",  label: "Current"  },
  { value: "other",    label: "Other"    },
];

const BankFormModal = ({ mode, initialData, vendorProfileId, onClose, onSuccess }) => {
  const isEdit = mode === "edit";

  const [form, setForm] = useState({
    bank_id:          initialData?.bank ?? "",
    beneficiary_name: initialData?.beneficiary_name ?? "",
    account_number:   initialData?.account_number   ?? "",
    ifsc:             initialData?.ifsc              ?? "",
    branch_address:   initialData?.branch_address   ?? "",
    account_type:     initialData?.account_type     ?? "savings",
    is_verified:      initialData?.is_verified      ?? false,
  });
  const [selectedBank, setSelectedBank] = useState(
    isEdit && initialData?.bank_name
      ? { id: initialData.bank, name: initialData.bank_name }
      : null
  );
  const [errors,  setErrors]  = useState({});
  const [saving,  setSaving]  = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => { document.body.style.overflow = ""; document.removeEventListener("keydown", onKey); };
  }, [onClose]);

  const validate = () => {
    const e = {};
    if (!isEdit && !form.bank_id) e.bank_id = "Please select a bank.";
    if (!form.beneficiary_name.trim()) e.beneficiary_name = "Beneficiary name is required.";
    if (!isEdit && !form.account_number.trim()) e.account_number = "Account number is required.";
    else if (!isEdit && !/^\d{6,18}$/.test(form.account_number.trim())) e.account_number = "Account number must be 6–18 digits.";
    if (!isEdit && !form.ifsc.trim()) e.ifsc = "IFSC code is required.";
    else if (!isEdit && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.ifsc.trim().toUpperCase())) e.ifsc = "Invalid IFSC format (e.g. SBIN0001234).";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setSaving(true);
    const loadId = toast.loading(isEdit ? "Updating bank details…" : "Creating bank record…");
    try {
      const payload = isEdit
        ? { beneficiary_name: form.beneficiary_name, branch_address: form.branch_address, account_type: form.account_type, is_verified: form.is_verified }
        : { bank_id: form.bank_id, beneficiary_name: form.beneficiary_name, account_number: form.account_number, ifsc: form.ifsc.toUpperCase(), branch_address: form.branch_address, account_type: form.account_type, is_verified: form.is_verified };

      if (isEdit && !initialData?.id) throw new Error("Bank record id is missing.");
      const { data } = isEdit ? await bankApi.patch(vendorProfileId, initialData.id, payload) : await bankApi.create(vendorProfileId, payload);

      if (data?.status >= 400) {
        const detail = data?.data?.detail || data?.data?.message || "Save failed";
        if (!isEdit && data?.status === 400 && detail.toLowerCase().includes("already exists")) {
          toast.dismiss(loadId);
          toast.info("Already Exists", "Bank record exists. Use Edit to update it.");
          onClose();
          return;
        }
        const fieldErrors = {};
        Object.entries(data?.data || {}).forEach(([k, v]) => {
          if (k !== "detail" && k !== "message") fieldErrors[k] = Array.isArray(v) ? v[0] : v;
        });
        if (Object.keys(fieldErrors).length > 0) setErrors(fieldErrors);
        throw new Error(detail);
      }

      toast.dismiss(loadId);
      toast.success(isEdit ? "Bank Updated" : "Bank Created", isEdit ? "Bank details updated successfully." : "Bank account created successfully.");
      onSuccess(data?.data ?? data);
      onClose();
    } catch (err) {
      toast.dismiss(loadId);
      if (!err.message?.toLowerCase().includes("already exists"))
        toast.error(isEdit ? "Update Failed" : "Create Failed", err.message || "An unexpected error occurred.");
    } finally {
      setSaving(false);
    }
  };

  const Field = ({ label, name, placeholder, mono, required, hint, readOnly }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", letterSpacing: ".03em" }}>
        {label}{required && <span style={{ color: "#dc2626" }}> *</span>}
      </label>
      <input
        value={form[name] ?? ""}
        readOnly={readOnly}
        onChange={(e) => {
          setForm((p) => ({ ...p, [name]: e.target.value }));
          if (errors[name]) setErrors((p) => ({ ...p, [name]: null }));
        }}
        placeholder={placeholder}
        style={{ padding: "9px 12px", border: `1px solid ${errors[name] ? "#fca5a5" : "#e2e8f0"}`, borderRadius: 8, fontSize: 13, background: readOnly ? "#f8fafc" : "#fff", color: mono ? "#1e40af" : "#1e293b", fontFamily: mono ? "monospace" : "inherit", outline: "none", transition: "border-color .15s" }}
        onFocus={(e) => { if (!readOnly) e.target.style.borderColor = errors[name] ? "#f87171" : "#3b82f6"; }}
        onBlur={(e) => { e.target.style.borderColor = errors[name] ? "#fca5a5" : "#e2e8f0"; }}
      />
      {errors[name] && <span style={{ fontSize: 11.5, color: "#dc2626", display: "flex", alignItems: "center", gap: 4 }}><AlertTriangleIcon />{errors[name]}</span>}
      {hint && !errors[name] && <span style={{ fontSize: 11.5, color: "#94a3b8" }}>{hint}</span>}
    </div>
  );

  const SelectField = ({ label, name }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", letterSpacing: ".03em" }}>{label}</label>
      <div style={{ position: "relative" }}>
        <select
          value={form[name]}
          onChange={(e) => setForm((p) => ({ ...p, [name]: e.target.value }))}
          style={{ width: "100%", padding: "9px 32px 9px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, background: "#fff", color: "#1e293b", outline: "none", appearance: "none", cursor: "pointer" }}>
          {ACCOUNT_TYPES.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", pointerEvents: "none" }}><ChevronDownIcon /></span>
      </div>
    </div>
  );

  const ToggleField = ({ label, name }) => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 12px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
      <span style={{ fontSize: 13, fontWeight: 550, color: "#374151", display: "flex", alignItems: "center", gap: 6 }}><LockIcon />{label}</span>
      <button type="button" onClick={() => setForm((p) => ({ ...p, [name]: !p[name] }))}
        style={{ width: 44, height: 24, borderRadius: 12, border: "none", cursor: "pointer", background: form[name] ? "#16a34a" : "#e2e8f0", position: "relative", transition: "background .2s", flexShrink: 0 }}>
        <span style={{ position: "absolute", top: 2, left: form[name] ? 22 : 2, width: 20, height: 20, borderRadius: "50%", background: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,.15)", transition: "left .2s" }} />
      </button>
    </div>
  );

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 }}
      onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 560, boxShadow: "0 24px 64px rgba(0,0,0,.20)", animation: "bk-fadeUp .2s ease", display: "flex", flexDirection: "column", maxHeight: "90vh" }}
        onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f1f5f9", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 9, background: isEdit ? "linear-gradient(135deg,#f59e0b,#d97706)" : "linear-gradient(135deg,#6366f1,#3b82f6)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {isEdit ? <EditIcon /> : <BankIcon />}
            </div>
            <div>
              <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#0f172a" }}>{isEdit ? "Edit Bank Details" : "Add Bank Account"}</h2>
              <p style={{ margin: "2px 0 0", fontSize: 12, color: "#94a3b8" }}>{isEdit ? "Update account information" : "Link a bank account for this vendor"}</p>
            </div>
          </div>
          <button onClick={onClose}
            style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex", padding: 6, borderRadius: 6 }}
            onMouseEnter={(e) => e.currentTarget.style.color = "#64748b"}
            onMouseLeave={(e) => e.currentTarget.style.color = "#94a3b8"}>
            <CloseIcon />
          </button>
        </div>

        <div style={{ overflowY: "auto", padding: "20px 24px", flex: 1, display: "flex", flexDirection: "column", gap: 14 }}>

          {!isEdit && (
            <BankSearchDropdown
              value={form.bank_id}
              selectedBank={selectedBank}
              onChange={() => { setForm((p) => ({ ...p, bank_id: "" })); setSelectedBank(null); }}
              onSelect={(bank) => { setSelectedBank(bank); setForm((p) => ({ ...p, bank_id: bank.id })); if (errors.bank_id) setErrors((p) => ({ ...p, bank_id: null })); }}
              error={errors.bank_id}
            />
          )}

          {isEdit && (
            <div style={{ padding: "10px 14px", background: "#f0f9ff", borderRadius: 8, border: "1px solid #bae6fd", display: "flex", alignItems: "center", gap: 8 }}>
              <BankIcon />
              <div>
                <div style={{ fontSize: 12, color: "#0369a1", fontWeight: 600 }}>Current Bank</div>
                <div style={{ fontSize: 13.5, fontWeight: 700, color: "#0c4a6e" }}>{initialData?.bank_name || "—"}</div>
              </div>
            </div>
          )}

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <div style={{ gridColumn: "1/-1" }}>
              <Field label="Beneficiary Name" name="beneficiary_name" placeholder="Full legal name" required />
            </div>
            {!isEdit && (
              <>
                <Field label="Account Number" name="account_number" placeholder="e.g. 9876543210" mono required hint="6–18 digit account number" />
                <Field label="IFSC Code" name="ifsc" placeholder="e.g. SBIN0001234" mono required hint="11-character code" />
              </>
            )}
            {isEdit && (
              <div style={{ gridColumn: "1/-1" }}>
                <Field label="Branch Address" name="branch_address" placeholder="Branch location" />
              </div>
            )}
            {!isEdit && (
              <div style={{ gridColumn: "1/-1" }}>
                <Field label="Branch Address" name="branch_address" placeholder="Branch location" />
              </div>
            )}
            <div style={{ gridColumn: "1/-1" }}>
              <SelectField label="Account Type" name="account_type" />
            </div>
            <div style={{ gridColumn: "1/-1" }}>
              <ToggleField label="Mark as Verified" name="is_verified" />
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, padding: "16px 24px", borderTop: "1px solid #f1f5f9", flexShrink: 0 }}>
          <button onClick={onClose} disabled={saving}
            style={{ padding: "9px 20px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: "pointer", background: "#fff", color: "#374151" }}>
            Cancel
          </button>
          <button onClick={handleSubmit} disabled={saving}
            style={{ padding: "9px 22px", border: "none", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: saving ? "not-allowed" : "pointer", background: saving ? "#93c5fd" : (isEdit ? "#f59e0b" : "#3b82f6"), color: saving ? "#fff" : "#fff", display: "flex", alignItems: "center", gap: 7 }}>
            {saving ? <><LoaderIcon size={14} /> Saving…</> : (isEdit ? <><EditIcon /> Update Bank</> : <><PlusIcon /> Create Bank</>)}
          </button>
        </div>
      </div>
    </div>
  );
};

const BankSkeleton = () => (
  <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <SkeletonBlock w="40%" h={20} />
      <SkeletonBlock w="120px" h={32} />
    </div>
    <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: 20, display: "flex", flexDirection: "column", gap: 12 }}>
      {[1,2,3,4,5,6].map((i) => (
        <div key={i} style={{ display: "flex", gap: 10, padding: "8px 0", borderBottom: "1px solid #f8fafc" }}>
          <SkeletonBlock w={16} h={16} />
          <SkeletonBlock w={160} h={13} />
          <SkeletonBlock w="40%" h={13} />
        </div>
      ))}
    </div>
  </div>
);

const AccountTypeBadge = ({ type, display }) => {
  const cfg = {
    savings: { bg: "#dbeafe", color: "#1d4ed8" },
    current: { bg: "#dcfce7", color: "#16a34a" },
    other:   { bg: "#f1f5f9", color: "#64748b" },
  };
  const c = cfg[type] || cfg.other;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600, background: c.bg, color: c.color }}>
      {display || type}
    </span>
  );
};

const BankAccount = ({ vendorProfileId }) => {
  const [bank,          setBank]          = useState(null);
  const [loading,       setLoading]       = useState(true);
  const [notFound,      setNotFound]      = useState(false);
  const [showForm,      setShowForm]      = useState(false);
  const [formMode,      setFormMode]      = useState("create");
  const [showDelete,    setShowDelete]    = useState(false);
  const [deleting,      setDeleting]      = useState(false);
  const [showCheque,    setShowCheque]    = useState(false);
  const [chequePreview, setChequePreview] = useState(false);

  const fetchBank = useCallback(async () => {
    setLoading(true);
    setNotFound(false);
    try {
      const { data } = await bankApi.get(vendorProfileId);
      if (data?.status === 404) { setNotFound(true); setBank(null); return; }
      if (data?.status === 401) { toast.error("Session Expired", "Please log in again."); return; }
      if (data?.status === 403) { toast.error("Access Denied", "You don't have permission to view bank details."); return; }
      setBank(data?.data ?? data);
    } catch (err) {
      toast.error(
        err?.name === "TypeError" ? "Network Error" : "Failed to Load",
        err?.name === "TypeError" ? "Unable to reach the server." : "Unable to fetch bank details. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }, [vendorProfileId]);

  useEffect(() => { fetchBank(); }, [fetchBank]);

  const handleDelete = async () => {
    setDeleting(true);
    const loadId = toast.loading("Deleting bank record…");
    try {
      if (!bank?.id) throw new Error("Bank record id is missing.");
      const { data } = await bankApi.delete(vendorProfileId, bank.id);
      if (data?.status >= 400 && data?.status !== 404) throw new Error("Delete failed");
      toast.dismiss(loadId);
      toast.success("Bank Deleted", "Bank account record has been permanently deleted.");
      setBank(null);
      setNotFound(true);
      setShowDelete(false);
    } catch (err) {
      toast.dismiss(loadId);
      toast.error("Delete Failed", err.message || "Could not delete bank record.");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div style={{ fontFamily: "'Inter', -apple-system, sans-serif", color: "#1e293b" }}>
      <style>{`
        @keyframes bk-shimmer  { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
        @keyframes bk-fadeUp   { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:none} }
        @keyframes bk-alIn     { from{opacity:0;transform:translateX(24px) scale(.97)} to{opacity:1;transform:none} }
        @keyframes bk-alOut    { from{opacity:1} to{opacity:0;transform:translateX(28px) scale(.95)} }
        @keyframes bk-spin     { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
        .bk-action-btn:hover   { opacity:.85 !important; }
        .bk-img-hover:hover    { transform:scale(1.02); }
        * { box-sizing:border-box; }
      `}</style>

      <ToastContainer />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        
          <div>
            <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: "#0f172a" }}>Bank Account</h2>
            <p style={{ margin: "2px 0 0", fontSize: 12.5, color: "#64748b" }}>Bank account &amp; cancelled cheque details</p>
          </div>
        </div>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button onClick={fetchBank} disabled={loading}
            style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "#fff", color: "#374151", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", boxShadow: "0 1px 3px rgba(0,0,0,.05)" }}
            onMouseEnter={(e) => e.currentTarget.style.background = "#f1f5f9"}
            onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}>
            {loading ? <LoaderIcon size={15} /> : <RefreshIcon />} Refresh
          </button>

          {!loading && notFound && (
            <button className="bk-action-btn"
              onClick={() => { setFormMode("create"); setShowForm(true); }}
              style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "#3b82f6", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "opacity .15s" }}>
              <PlusIcon /> Add Bank Account
            </button>
          )}

          {!loading && bank && (
            <>
              <button className="bk-action-btn"
                onClick={() => { setShowCheque(true); }}
                style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "#6366f1", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "opacity .15s" }}>
                <UploadIcon /> {bank.cancelled_cheque_url ? "Replace Cheque" : "Upload Cheque"}
              </button>
              <button className="bk-action-btn"
                onClick={() => { setFormMode("edit"); setShowForm(true); }}
                style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "#f59e0b", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "opacity .15s" }}>
                <EditIcon /> Edit
              </button>
              <button className="bk-action-btn"
                onClick={() => setShowDelete(true)}
                style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "#fee2e2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "opacity .15s" }}>
                <TrashIcon /> Delete
              </button>
            </>
          )}
        </div>
      </div>

      {loading ? (
        <BankSkeleton />
      ) : notFound ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "60px 20px", background: "#fff", borderRadius: 12, border: "1px dashed #e2e8f0", gap: 12, textAlign: "center" }}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg,#f1f5f9,#e2e8f0)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5">
              <line x1="12" y1="1" x2="12" y2="23" />
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </div>
          <div>
            <p style={{ margin: "0 0 6px", fontSize: 16, fontWeight: 700, color: "#374151" }}>No Bank Account Found</p>
            <p style={{ margin: 0, fontSize: 13.5, color: "#94a3b8" }}>This vendor doesn't have a bank account linked yet.</p>
          </div>
          <button onClick={() => { setFormMode("create"); setShowForm(true); }}
            style={{ marginTop: 4, display: "flex", alignItems: "center", gap: 7, padding: "10px 22px", background: "#3b82f6", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
            <PlusIcon /> Add Bank Account
          </button>
        </div>
      ) : bank ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 16, animation: "bk-fadeUp .2s ease" }}>

          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {[
              {
                label: "Account Type",
                value: <AccountTypeBadge type={bank.account_type} display={bank.account_type_display} />,
                bg: "#f8fafc", border: "#e2e8f0",
              },
              {
                label: "Verification",
                value: bank.is_verified
                  ? <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, fontWeight: 700, color: "#16a34a", background: "#dcfce7", padding: "2px 8px", borderRadius: 6 }}><CheckIcon /> Verified</span>
                  : <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, fontWeight: 700, color: "#dc2626", background: "#fee2e2", padding: "2px 8px", borderRadius: 6 }}>✕ Not Verified</span>,
                bg: bank.is_verified ? "#f0fdf4" : "#fff1f2", border: bank.is_verified ? "#bbf7d0" : "#fecdd3",
              },
              {
                label: "Last Updated",
                value: <span style={{ fontSize: 13, fontWeight: 600, color: "#334155" }}>{bank.updated_at ?? "—"}</span>,
                bg: "#f8fafc", border: "#e2e8f0",
              },
              {
                label: "Cheque",
                value: bank.cancelled_cheque_url
                  ? <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, fontWeight: 700, color: "#16a34a", background: "#dcfce7", padding: "2px 8px", borderRadius: 6 }}><CheckIcon /> Uploaded</span>
                  : <span style={{ fontSize: 12, fontWeight: 700, color: "#94a3b8", background: "#f1f5f9", padding: "2px 8px", borderRadius: 6 }}>Not Uploaded</span>,
                bg: "#f8fafc", border: "#e2e8f0",
              },
            ].map(({ label, value, bg, border }) => (
              <div key={label} style={{ padding: "10px 16px", background: bg, border: `1px solid ${border}`, borderRadius: 10, display: "flex", flexDirection: "column", gap: 4 }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".06em" }}>{label}</span>
                {value}
              </div>
            ))}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>

            <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
              <div style={{ padding: "12px 16px", background: "linear-gradient(135deg,#f0fdf4,#fff)", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ width: 30, height: 30, borderRadius: 8, background: "#dcfce7", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <BankIcon />
                </div>
                <span style={{ fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>Account Details</span>
              </div>
              <div style={{ padding: "12px 16px" }}>
                <InfoRow icon={<BankIcon />}    label="Bank Name"         value={bank.bank_name} />
                <InfoRow icon={<UserIcon />}    label="Beneficiary Name"  value={bank.beneficiary_name} />
                <InfoRow icon={<BankIcon />}    label="Account Number"    value={bank.account_number} mono />
                <InfoRow icon={<BankIcon />}    label="IFSC Code"         value={bank.ifsc} mono />
                <InfoRow icon={<MapPinIcon />}  label="Branch Address"    value={bank.branch_address} />
                <InfoRow icon={<BankIcon />}    label="Account Type"
                  badge={<AccountTypeBadge type={bank.account_type} display={bank.account_type_display} />} />
                <InfoRow icon={<CalendarIcon />} label="Last Updated"     value={bank.updated_at} />
                <div style={{ marginTop: 12 }}>
                  <InfoRow icon={<LockIcon />}  label="Verification Status"
                    badge={
                      bank.is_verified
                        ? <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, fontWeight: 700, color: "#16a34a", background: "#dcfce7", padding: "3px 10px", borderRadius: 20 }}><CheckIcon /> Verified</span>
                        : <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, fontWeight: 700, color: "#dc2626", background: "#fee2e2", padding: "3px 10px", borderRadius: 20 }}>✕ Not Verified</span>
                    }
                  />
                </div>
              </div>
            </div>

            <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
              <div style={{ padding: "12px 16px", background: "linear-gradient(135deg,#eff6ff,#fff)", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 30, height: 30, borderRadius: 8, background: "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FileIcon />
                  </div>
                  <span style={{ fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>Cancelled Cheque</span>
                </div>
                <button className="bk-action-btn"
                  onClick={() => setShowCheque(true)}
                  style={{ display: "flex", alignItems: "center", gap: 5, padding: "5px 12px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 7, fontSize: 12, fontWeight: 600, color: "#2563eb", cursor: "pointer" }}>
                  <UploadIcon /> {bank.cancelled_cheque_url ? "Replace" : "Upload"}
                </button>
              </div>

              {bank.cancelled_cheque_url ? (
                <div>
                  <div style={{ position: "relative", height: 180, background: "#f8fafc", overflow: "hidden", cursor: "pointer" }}
                    onClick={() => setChequePreview(true)}>
                    <img
                      src={bank.cancelled_cheque_url}
                      alt="Cancelled Cheque"
                      className="bk-img-hover"
                      style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform .25s" }}
                      onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
                    />
                    <div style={{ display: "none", height: "100%", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 8, color: "#94a3b8" }}>
                      <FileIcon />
                      <span style={{ fontSize: 12 }}>Preview unavailable</span>
                    </div>
                    <div style={{ position: "absolute", inset: 0, background: "rgba(15,23,42,.35)", display: "flex", alignItems: "center", justifyContent: "center", opacity: 0, transition: "opacity .2s" }}
                      onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                      onMouseLeave={(e) => e.currentTarget.style.opacity = 0}>
                      <span style={{ background: "rgba(255,255,255,.9)", borderRadius: 8, padding: "7px 14px", fontSize: 12.5, fontWeight: 700, color: "#0f172a", display: "flex", alignItems: "center", gap: 6 }}>
                        <EyeIcon /> Click to Preview
                      </span>
                    </div>
                  </div>

                  <div style={{ padding: "10px 14px", display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px solid #f8fafc" }}>
                    <span style={{ fontSize: 12.5, color: "#64748b", fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "65%" }}>
                      {bank.cancelled_cheque_name}
                    </span>
                    <a href={bank.cancelled_cheque_url} target="_blank" rel="noreferrer"
                      style={{ display: "flex", alignItems: "center", gap: 5, padding: "5px 12px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 7, color: "#2563eb", fontSize: 12, fontWeight: 600, textDecoration: "none", whiteSpace: "nowrap", flexShrink: 0 }}>
                      <LinkIcon /> Open Full
                    </a>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 20px", gap: 10, textAlign: "center" }}>
                  <div style={{ width: 52, height: 52, borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                    </svg>
                  </div>
                  <p style={{ margin: 0, fontSize: 13.5, fontWeight: 600, color: "#374151" }}>No Cheque Uploaded</p>
                  <p style={{ margin: 0, fontSize: 12.5, color: "#94a3b8" }}>Upload a cancelled cheque for verification</p>
                  <button onClick={() => setShowCheque(true)}
                    style={{ marginTop: 4, display: "flex", alignItems: "center", gap: 6, padding: "8px 18px", background: "#6366f1", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                    <UploadIcon /> Upload Now
                  </button>
                </div>
              )}
            </div>
          </div>

        
        </div>
      ) : null}

      {showForm && (
        <BankFormModal
          mode={formMode}
          initialData={formMode === "edit" ? bank : null}
          vendorProfileId={vendorProfileId}
          onClose={() => setShowForm(false)}
          onSuccess={(updated) => { setBank(updated); setNotFound(false); }}
        />
      )}

      {showCheque && (
        <ChequeUploadModal
          vendorProfileId={vendorProfileId}
          bankId={bank?.id}
          onClose={() => setShowCheque(false)}
          onSuccess={(updated) => setBank(updated)}
        />
      )}

      {showDelete && (
        <ConfirmDeleteModal
          loading={deleting}
          onConfirm={handleDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}

      {chequePreview && bank?.cancelled_cheque_url && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.85)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3000, padding: 20 }}
          onClick={() => setChequePreview(false)}>
          <div style={{ position: "relative", maxWidth: "90vw", maxHeight: "90vh" }} onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setChequePreview(false)}
              style={{ position: "absolute", top: -14, right: -14, width: 32, height: 32, borderRadius: "50%", background: "#fff", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(0,0,0,.3)", zIndex: 1 }}>
              <CloseIcon />
            </button>
            <img src={bank.cancelled_cheque_url} alt="Cancelled Cheque"
              style={{ maxWidth: "90vw", maxHeight: "85vh", borderRadius: 12, objectFit: "contain", boxShadow: "0 24px 64px rgba(0,0,0,.4)" }} />
            <div style={{ textAlign: "center", marginTop: 10 }}>
              <a href={bank.cancelled_cheque_url} target="_blank" rel="noreferrer"
                style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 18px", background: "#fff", borderRadius: 8, color: "#1e293b", fontSize: 13, fontWeight: 600, textDecoration: "none" }}>
                <LinkIcon /> Open in New Tab
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BankAccount;
